import { useRouteError } from "react-router-dom";
import Button from './ui/Button';

// Router-level fallback (RR's `errorElement`). `lazyWithRetry` in
// routes/index.jsx already auto-reloads once on a chunk-load failure, so
// anything reaching this component is either a second consecutive chunk
// failure (real outage, not a stale-cache blip) or an unrelated render error.
export default function RouteErrorBoundary() {
  const error = useRouteError();

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
      <p className="text-gray-500 mb-4">
        Please refresh the page. If the problem continues, contact support.
      </p>
      <Button onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}
